/* globals Forms */
import AbilitySelector from 'lib/ability_selector'
import { get } from '@rails/request.js'

window['permission_presets#new'] = function () {
  rolesLogic()
}

window['permission_presets#edit'] = function () {
  rolesLogic()
}

window['permission_presets#index'] = function () {
  $('.toggle_active').on('change', function () {
    const id = $(this).data('preset-id')
    const value = $(this).is(':checked')
    $.post(`/permission_presets/${id}/toggle_active/`, { active: value })
  })
}

const rolesLogic = function () {
  const abilitySelector = new AbilitySelector(gon, 'permission_preset')

  $('.permission_preset_role input').on('change', async function () {
    const block = $('#abilities_collection_block')
    const role = $(this).val()

    block.addClass('loading')

    try {
      const response = await get(
        '/permission_presets/additional_abilities',
        {
          query: {
            role,
            preset_id: gon.preset_id
          },
          responseKind: 'script'
        }
      )

      if (!response.ok) throw new Error(`HTTP ${response.status}`)

      Forms.initCheckbox()
      abilitySelector.init_checked()
    } catch (error) {
      console.error('Failed to load abilities:', error)
    } finally {
      block.removeClass('loading')
    }
  })
}
